import { render, staticRenderFns } from "./attributeInformation.vue?vue&type=template&id=8a1feb6c&scoped=true&"
import script from "./attributeInformation.vue?vue&type=script&lang=js&"
export * from "./attributeInformation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a1feb6c",
  null
  
)

export default component.exports